import { computed, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../shared/store/common/component-store-v2.factory';
import { ServiceGridItemObject } from '@it2go/types';

@Injectable()
export class UsersFiltersStore extends ComponentStoreV2Factory {
    public allowedServiceIds = computed(() => {
        const services = this.globalGlobalStore.organizationStore.services();

        return services
            .filter((it: ServiceGridItemObject) => {
                const canUpdate = this.isAllowedForService('user.update', it.id)();
                const canDelete = this.isAllowedForService('user.delete', it.id)();
                const canCreate = this.isAllowedForService('user.create', it.id)();

                return canCreate || canUpdate || canDelete;
            })
            .map((it: ServiceGridItemObject) => it.id);
    });
}
